import { render, staticRenderFns } from "./ListItems.vue?vue&type=template&id=0cb564e4"
import script from "./ListItems.vue?vue&type=script&lang=js"
export * from "./ListItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports